import React from 'react';

import { getRedirect } from '../../util/server-util';

export default function HiddenRedirect() {
  const redirect = getRedirect();
  return redirect ? <input type='hidden' name='redirect' value={redirect} /> : null;
}
